import { useState } from 'react';
import { Box, Button, Dialog, Flex, Text, TextField } from '@radix-ui/themes';
import { toast } from 'react-toastify';
import api from '../../api';
import { useDispatch } from 'react-redux';
import { updateStudents } from '../../redux/slices/guardianSlice';

const GuardianLinkTeacher = ({ studentId, subjectId, onComplete }) => {
    const [teacherHandle, setTeacherHandle] = useState('');
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const handleSubmit = async () => {
        if (!teacherHandle) {
            toast.error('Please enter a teacher handle');
            return;
        }

        try {
            setLoading(true);
            const response = await api.post('/students/link-teacher', {
                student_id: studentId,
                subject_id: subjectId,
                teacher_handle: teacherHandle.replace('@', '') // Remove @ if user included it
            });

            // Update the students state with the new subscription
            dispatch(updateStudents(response.data.students));

            toast.success('Successfully linked to teacher\'s course');
            onComplete?.();
        } catch (error) {
            toast.error(error.response?.data?.message || 'Failed to link to teacher\'s course');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box>
            <Text size="2" mb="2">
                Enter the teacher's handle to subscribe to their course. The handle should be in the format @teacherhandle
            </Text>

            <Flex direction="column" gap="2">
                <TextField.Root>
                    <TextField.Input
                        placeholder="@teacherhandle"
                        value={teacherHandle}
                        onChange={(e) => setTeacherHandle(e.target.value)}
                    />
                </TextField.Root>

                <Button
                    onClick={handleSubmit}
                    disabled={loading || !teacherHandle}
                >
                    {loading ? 'Linking...' : 'Link to Teacher'}
                </Button>
            </Flex>
        </Box>
    );
};

export default GuardianLinkTeacher;
